import PropTypes from "prop-types"
import { Link } from "react-router-dom"

import { ItemAction } from "areas/cart/components"

import LineItemDetails from "./line-item-details"

const LineItemInfo = ({ item, toggleRemoveItemDialog }) => {
  return (
    <div>
      <h3
        className="text-16 leading-18 mb-16 font-medium tracking-tight text-black"
        data-cy="cart-line-item-info-title"
      >
        {item.title}
      </h3>
      {item.in_stock && (
        <>
          <div className="text-link">
            <ItemAction asChild>
              <Link
                data-cy={`cart-modify-btn-${item.style_code}`}
                data-lc="line-item-info"
                to={item.modify_url}
              >
                Modify
              </Link>
            </ItemAction>
            <ItemAction
              data-cy={`cart-remove-btn-${item.style_code}`}
              onClick={() => toggleRemoveItemDialog(true)}
            >
              Remove
            </ItemAction>
          </div>
          <LineItemDetails item={item} />
        </>
      )}
    </div>
  )
}

LineItemInfo.propTypes = {
  item: PropTypes.object,
  toggleRemoveItemDialog: PropTypes.func,
}

export default LineItemInfo
